<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mt-2 mb-4 pb-2 pt-2">Edit Terms</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12 col-xl-8">
				<form @submit.prevent="onSubmit">
					<div class="lightgray-content p-3 rounded mb-4">
						<div class="form-group input-content">
							<label>Text</label>
							<wysiwyg v-model="terms.text" />
						</div>
					</div>
					<div class="text-right">
						<button type="submit" class="button large-button">Submit</button>
					</div>
				</form>
			</div><!--col-->
		</div><!--row-->
	</div>
</template>


<script>
export default {
	data : function(){
		return {
			terms : {
				text : '',
			}
		}
	},
	created : function(){
		this.getTerms();
	},	
	methods : {
		getTerms : function(){

			this.$store.dispatch('getTerms', {}).then((res) => {
				this.terms = res.data;
			}).catch((error) => {
				console.log(error);
			});
		},
		onSubmit : function(){
			this.$validator.validateAll().then((result) => {
				if(result){
					this.$store.dispatch('editTerms', this.terms).then((res) => {

					}).catch((error) => {
						
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/terms/AdminTermsEditComponent.vue